import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { LOCAL_STORAGE_KEYS } from '@/lib/local-storage-keys'

interface SidebarStore {
  open: boolean
  setOpen: (open: boolean) => void
  clearSidebar: () => void
}

export const useSidebarStore = create<SidebarStore>()(
  // @ts-ignore - Known issue with Zustand 5.x and TypeScript strict mode with persist middleware
  persist(
    (set) => ({
      open: true,

      setOpen: (open) => set({ open }),

      clearSidebar: () => set({ open: true }),
    }),
    {
      name: LOCAL_STORAGE_KEYS.SIDEBAR,
    },
  ),
)
